export const localeToCountry = (
  locale: string | undefined
): 'Australia' | 'New Zealand' =>
  locale === 'en-NZ' ? 'New Zealand' : 'Australia'
